// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup {\n  position: absolute;\n  z-index: 100;\n  box-shadow: 0px 4px 8px rgba(26, 26, 26, 0.1);\n  border-radius: 4px;\n  background: #ffffff;\n  animation-name: popup-show;\n  animation-duration: 0.367s;\n  animation-timing-function: cubic-bezier(0.1, 0.9, 0.2, 1);\n  animation-fill-mode: both;\n}\n.popup-inner {\n  position: relative;\n  background-color: #ffffff;\n  height: 100%;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
